import theme from '@styles/theme';
import { ThemeUIStyleObject } from 'theme-ui';
export type CtaButtonVariant = 'outline' | 'filled';
type StylesType = {
  button: (variant: CtaButtonVariant, color?: string) => ThemeUIStyleObject;
};
const styles: StylesType = {
  button: (variant = 'outline', color) => {
    const buttonColor = color || theme.rawColors.accent700;
    const isOutline = variant === 'outline';
    const heights = [36, 36, 36, 36, 36, 47];
    const minHeights = heights;
    const maxHeights = heights;
    return {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: theme.fonts.uniform,
      fontWeight: theme.fontWeights.normal,
      lineHeight: '140%',
      letterSpacing: '5%',
      height: heights,
      minHeight: minHeights,
      maxHeight: maxHeights,
      cursor: 'pointer',
      textDecoration: 'none',
      textTransform: 'lowercase',
      fontSize: ['16px',
      // mobile
      '16px',
      // mobilelg
      '16px',
      // tablet
      '16px',
      // tabletlg
      '20px',
      // desktop
      '20px' // widescreen
      ],
      padding: ['8px 24px 6px', '8px 24px 6px', '8px 24px 6px', '8px 24px 6px', '8px 24px 6px', '10px 24px 9px'],
      backgroundColor: isOutline ? theme.rawColors.neutralWhite : buttonColor,
      color: isOutline ? theme.rawColors.neutralBlack : theme.rawColors.neutralWhite,
      border: 'none',
      transition: 'all 0.3s ease',
      '&:visited': {
        backgroundColor: isOutline ? theme.rawColors.neutralWhite : buttonColor,
        color: isOutline ? theme.rawColors.neutralBlack : theme.rawColors.neutralWhite
      },
      '&:hover': {
        backgroundColor: isOutline ? theme.rawColors.neutralBlack : theme.rawColors.darkGrey700,
        color: theme.rawColors.neutralWhite
      },
      '&:focus-visible': {
        outline: `2px solid ${theme.rawColors.blue500}`,
        outlineOffset: '2px'
      }
    };
  }
};
export default styles;